import { Badge } from "../atoms/Badge"
import { cn } from "../utils"

type NewBadgeVariant = "secondary" | "testing"

type NewBadgeProps = {
  label: string
  variant?: NewBadgeVariant
  className?: string
}

export const NewBadge = ({ label, className, variant = "testing" }: NewBadgeProps) => {
  return (
    <Badge variant={variant} className={cn("shrink-0", className)}>
      <span className="text-xs font-bold">{label}</span>
    </Badge>
  )
}
